var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.11,
    height: 41.543,
    viewBox: "0 0 35.11 41.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M17.48,24.668a7.328,7.328,0,0,0,7.434-7.247A7.546,7.546,0,0,0,17.48,9.915a7.328,7.328,0,0,0-7.434,7.247A7.731,7.731,0,0,0,17.48,24.668ZM5,5A17.947,17.947,0,0,1,29.958,5a16.881,16.881,0,0,1,0,24.33L17.48,41.492,5,29.327A17.353,17.353,0,0,1,5,5Z",
    transform: "translate(-0.025 0.05)",
    fill: "#ff7b7b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMapIcon);
export default __webpack_public_path__ + "static/media/contactMapIcon.2d1da8de446346a206a4ea17d3594e76.svg";
export { ForwardRef as ReactComponent };